// extracted by mini-css-extract-plugin
export default {"wrapper":"Ambassadors_wrapper__p+xoF","title":"Ambassadors_title__Nwu5q"};